import { LatLngExpression } from "leaflet";
import "leaflet/dist/leaflet.css";
import React, { useContext } from "react";
import { LayoutContext } from "../../../../context/LayoutContext";
import { getAirportConfig } from "../../../../utils/common/CommonHelperFunctions";
import {
  getStandDisplayStatus,
  mapGateFlightInfo,
} from "../../../../utils/maps/MapHelperFunctions";
import CircularMarker from "./CircularMarker";
import GateToolTip from "./GateToolTip";

interface IGateMarkersProps {
  airportCode: string;
  gatesData: any[];
}

const GateMarkers: React.FC<IGateMarkersProps> = ({
  airportCode,
  gatesData,
}) => {
  const { timezone, currentTime } = useContext(LayoutContext);
  const { timeZoneId: airportTimeZone } = getAirportConfig(airportCode);

  if (!gatesData.length) {
    return null;
  }

  return (
    <>
      {gatesData.map((s: any, idx: number) => {
        const position: LatLngExpression = [s.latitude, s.longitude];
        const displayStatus = getStandDisplayStatus(s.status, s.occupancy);

        return (
          <CircularMarker
            key={s.id}
            position={position}
            color={displayStatus.color}
            label={String(s.id).slice(0, 3)}
            size={30}
            tooltip={
              <GateToolTip
                gateName={s.name}
                displayStatusLabel={displayStatus.label}
                displayStatusColor={displayStatus.color}
                current={mapGateFlightInfo(
                  s.flightData?.current,
                  currentTime,
                  airportTimeZone,
                  timezone
                )}
                next={mapGateFlightInfo(
                  s.flightData?.next,
                  currentTime,
                  airportTimeZone,
                  timezone
                )}
              />
            }
            zIndexOffset={1000 + idx}
          />
        );
      })}
    </>
  );
};

export default GateMarkers;
